<template>
  <v-app id="inspire">
     <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-layout
            v-if="item.heading"
            :key="item.heading"
            row
            align-center
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex
              xs6
              class="text-xs-center"
            >
              <a
                href="#!"
                class="body-2 black--text"
              >EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
          v-else
            :key="item.text"
            :to="{name: item.component_to}"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
       color="#7c167d"
      dark
    >
      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-3"
       
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" ></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down"></span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      
        <v-icon
          medium
          @click="salir(item)"
        >
          mdi-exit-to-app
        </v-icon>
    </v-app-bar>
    <v-content>
      <v-container
      >
        <v-slide-y-transition mode="out-in">
          <router-view />
        </v-slide-y-transition>
      </v-container>
    </v-content>


    <v-footer
      color="#7c167d"
      app
    >
      <v-row
      justify="center"
      >
        <span class="white--text">comparatuseguro &copy; 2020</span>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
    items: [
       { text: 'Cotizaciones', component_to: 'cotizaciones' },
       { text: 'Propuestas', component_to: 'propuestas' },
       { text: 'Pendientes Emisión', component_to: 'companiaEmision' },
      // { text: 'Pólizas', component_to: 'polizas' },
      { text: 'Bitácora', component_to: 'bitacora' },
      { text: 'Usuarios', component_to: 'usuarios' },
    ],
    }),
    methods: {
      salir() {
       this.$router.push("/");
      }
    }
  }
</script>
